<template>
    <div>
        <ns-loader
            ref="ns-loader"
            :to-load="toLoad"
            @dataFetched="onDataFetched"
        >
            <loading-template slot="loader"></loading-template>
            <el-tabs
                slot="content"
                class="gcmcn-tabs"
                style="margin-top: 30px;"
                v-model="activeName"
                :key="feed.uid"
            >
                <el-tab-pane label="Rights" name="rights">
                    <feed-rights
                        :feed="feed"
                        :broadcast-right="broadcastRight"
                        :resource-configurations="feedResourceConfigurations"
                        @on-update-broadcast-right="sendEmit"
                    ></feed-rights>
                </el-tab-pane>
                <el-tab-pane label="Details" name="details">
                    <div class="gcmcn-card-gradient entity-details">
                        <div class="" v-separator-link="200">
                            <div class="feed-details-container gcmcn-card">
                                <div class="feed-details">
                                    <el-row :gutter="20">
                                        <el-col :span="16">
                                            <div class="details-title">Name</div>
                                            <p>{{ feed.display_name }}</p>
                                        </el-col>
                                        <el-col :span="8">
                                            <div class="text-right">
                                                <el-tooltip
                                                    :disabled="!disabledStartNowButton"
                                                    placement="top"
                                                >
                                                    <div slot="content">
                                                        {{disabledStartReason}}
                                                    </div>
                                                    <span style="margin-right: 10px;">
                                                        <el-button
                                                            v-if="
                                                                (userIsEntityAdmin(this.entityUid)
                                                                || userIsAtLeastAdmin)
                                                                    && !feedIsRunning
                                                            "
                                                            type="success"
                                                            class="gcmcn-success-btn small"
                                                            :loading="loading"
                                                            :disabled="disabledStartNowButton"
                                                            @click="startFeedNow"
                                                        >Start now</el-button>
                                                    </span>
                                                </el-tooltip>
                                                <el-button
                                                    type="primary"
                                                    class="gcmcn-primary-btn small"
                                                    :loading="loading"
                                                    :disabled="feed.status === 'FINISHED'"
                                                    @click="editFeed"
                                                    style="margin-right: 10px;"
                                                >Edit</el-button>
                                                <el-popover
                                                    v-if="feedCanBeStopped"
                                                    ref="popover-stop-feed"
                                                    placement="bottom"
                                                    width="148"
                                                    trigger="click"
                                                    popper-class="dark-popper"
                                                    @hide="hidePopoverStopFeed"
                                                >
                                                    <div>
                                                        <div class="popover-title">Confirm stop feed?</div>
                                                        <div class="actions">
                                                            <el-button type="text" class="decline" @click="hidePopoverStopFeed()">No</el-button>
                                                            <el-button type="text" class="accept" @click="stopFeed()">Yes</el-button>
                                                        </div>
                                                    </div>

                                                    <el-button
                                                        slot="reference"
                                                        type="danger"
                                                        class="gcmcn-danger-btn small"
                                                        style="margin-right: 10px;"
                                                        :loading="loading"
                                                    >Stop feed</el-button>
                                                </el-popover>
                                                <el-tooltip
                                                    :disabled="enableDeletion"
                                                    placement="top"
                                                    content="You can't delete a feed if takers have rights"
                                                >
                                                    <el-popover
                                                        ref="popover"
                                                        placement="bottom"
                                                        width="142"
                                                        :trigger="'click'"
                                                        popper-class="dark-popper"
                                                        @hide="hideDeletePopover"
                                                    >
                                                        <div class="popover-title">Confirm feed deletion</div>
                                                        <div class="actions">
                                                            <el-button type="text" class="decline" @click="hideDeletePopover()">No</el-button>
                                                            <el-button type="text" class="accept" @click="deleteFeed()">Yes</el-button>
                                                        </div>
                                                        <el-button
                                                            slot="reference"
                                                            type="danger"
                                                            class="gcmcn-danger-btn small"
                                                            :disabled="!enableDeletion"
                                                            :loading="loading"
                                                            @click="popOverOpened = true"
                                                        >Delete</el-button>
                                                    </el-popover>
                                                </el-tooltip>
                                                <el-button
                                                    v-if="feedInputCanBeModified"
                                                    type="warning"
                                                    class="gcmcn-primary-btn gcmcn-this-warning-btn small"
                                                    :loading="loading"
                                                    @click="openModalEditInput"
                                                    style="margin-left: 10px;"
                                                >Edit input</el-button>
                                            </div>
                                        </el-col>
                                    </el-row>

                                    <div class="details-title">Description</div>
                                    <p class="details--description">{{ feedDescription }}</p>

                                    <div class="details-title">Zixi/SRT</div>
                                    <p class="details--description">{{ feedSourceType }}</p>

                                    <el-row :gutter="20">
                                        <el-col :span="12">
                                            <div class="details-title">Universe</div>
                                            <p>{{ universe ? universe.display_name : '' }}</p>
                                        </el-col>
                                        <el-col :span="12">
                                            <div class="details-title">Event</div>
                                            <p>{{ event.name }}</p>
                                        </el-col>
                                    </el-row>
                                    <div
                                        v-if="feed.feed_resource_uid"
                                        class="mb-1"
                                    >
                                        <div class="details-title">Feed Resource</div>
                                        <div>{{ feedResourceName }}</div>
                                    </div>
                                    <div v-if="userIsAtLeastAdmin || userIsEntityAdmin(entityUid)">
                                        <el-row
                                            v-if="feed.confirmed && feed.booking_type === 'automatic'"
                                            :gutter="20"
                                        >
                                            <el-col :span="12">
                                                <div class="details-title">Main source</div>
                                                <p>{{ mainSourceName }}</p>
                                            </el-col>
                                            <el-col :span="12">
                                                <div class="details-title">Backup source</div>
                                                <p>{{ backupSourceName }}</p>
                                            </el-col>
                                        </el-row>

                                        <el-row
                                            v-else-if="feed.confirmed"
                                            :gutter="20"
                                        >
                                            <el-col :lg="12" :md="24">
                                                <div class="details-title">Main IP</div>
                                                <p>{{ videoSourceMainDetails }}</p>
                                            </el-col>
                                            <el-col :lg="12" :md="24">
                                                <div class="details-title">Backup IP</div>
                                                <p>{{ videoSourceBackupDetails }}</p>
                                            </el-col>
                                        </el-row>
                                    </div>
                                    <div
                                        v-if="feed.confirmed && (userIsAtLeastAdmin || userIsEntityAdmin(entityUid)) && videoSource"
                                    >
                                        <div class="details-title">Globecast region</div>
                                        <p>{{ videoSource.datacenter_obj.name }}</p>
                                    </div>

                                    <div class="details-title">Status</div>
                                    <p>{{ feed.status }}</p>
                                    <div class="details-title">Duration </div>
                                    <p>{{ duration }} MIN</p>

                                    <el-row :gutter="20">
                                        <el-col :span="8">
                                            <div class="details-title">Work Order</div>
                                            <div>{{ feed.booking_key }}</div>
                                        </el-col>
                                        <el-button
                                            v-if="userIsAtLeastAdmin || userIsEntityAdmin(entityUid)"
                                            type="warning"
                                            class="gcmcn-primary-btn small"
                                            :loading="loading"
                                            :disabled="feed.status === 'FINISHED'"
                                            @click="updateWorkOrder"
                                            style="margin-right: 10px;"
                                        >
                                            Edit Work Order
                                        </el-button>
                                        <el-col :span="8">

                                        </el-col>
                                    </el-row>


                                    <el-row :gutter="20">
                                        <el-col :span="8">
                                            <div class="details-title">Start time </div>
                                            <p>{{ startDate }}</p>
                                        </el-col>
                                        <el-col :span="8">
                                            <div class="details-title">At </div>
                                            <p>{{ startTimeUTC }}<small class="timezone-label">UTC 0</small></p>
                                            <p>{{ startTimeLocal }}<small class="timezone-label">LOCAL TIME</small></p>
                                        </el-col>
                                    </el-row>
                                    <el-row :gutter="20">
                                        <el-col :span="8">
                                            <div class="details-title">End time </div>
                                            <p>{{ endDate }}</p>
                                        </el-col>
                                        <el-col :span="8">
                                            <div class="details-title">At </div>
                                            <p>{{ endTimeUtc }}<small class="timezone-label">UTC 0</small></p>
                                            <p>{{ endTimeLocal }}<small class="timezone-label">LOCAL TIME</small></p>
                                        </el-col>
                                        <el-col :span="8">
                                            <el-button
                                                v-if="canExtendFeed"
                                                type="danger"
                                                class="gcmcn-danger-btn small"
                                                :loading="loading"
                                                @click="openModalExtendFeed"
                                            >Extend</el-button>
                                        </el-col>
                                    </el-row>

                                    <el-button
                                        v-if="userIsAtLeastAdmin || userIsEntityAdmin(entityUid)"
                                        :disabled="disableConfirmButton"
                                        type="warning"
                                        class="gcmcn-warning-btn small"
                                        @click="confirmFeed"
                                    >
                                        Book feed
                                    </el-button>
                                    <el-button
                                        v-if="feed.source_type === 'external'"
                                        :disabled="!['STARTING', 'RUNNING'].includes(feed.status)"
                                        :loading="loading"
                                        type="primary"
                                        class="gcmcn-primary-btn small"
                                        @click="openEmailModal"
                                    >
                                        Resend emails
                                    </el-button>
                                </div>
                                <div v-if="feed.source_type === 'external'">
                                    <div v-if="!expanded" class="more">
                                        See more
                                        <el-button type="text" icon="el-icon-arrow-down" @click="expanded = true"></el-button>
                                    </div>
                                    <div v-else class="more">
                                        See less
                                        <el-button type="text" icon="el-icon-arrow-up" @click="expanded = false"></el-button>
                                    </div>
                                    <feed-source-external-info v-if="expanded" :feed="feed"></feed-source-external-info>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="Configurations" name="configurations">
                    <configuration-view
                        :feed-configurations="configurations"
                        :broadcast-right="broadcastRight"
                        :feed="feed"
                        :event="event"
                        @on-configuration-created="triggerRefresh"
                        @on-configuration-cancelled="triggerRefresh"
                        @trigger-refresh="triggerRefresh"
                    ></configuration-view>
                </el-tab-pane>
            </el-tabs>
        </ns-loader>

        <modal-extend-feed
            ref="modal-extend-feed"
            @watch-feed-modification-request="watchFeedModificationRequest"
        ></modal-extend-feed>
        <modal-confirm-feed
            ref="modal-confirm-feed"
            @watch-feed-modification-request="watchFeedModificationRequest"
            @on-trigger-refresh="onTriggerRefresh"
        ></modal-confirm-feed>
        <feed-modification
            ref="modal-edit-input"
            @watch-feed-modification-request="watchFeedModificationRequest"
        ></feed-modification>
        <modal-send-email
            ref="modal-send-email"
            @watch-feed-modification-request="watchFeedModificationRequest"
        ></modal-send-email>
        <feed-update-work-order
            ref="feed-update-work-order"
            @on-trigger-refresh="onTriggerRefresh"
        ></feed-update-work-order>
    </div>
</template>

<script>
import Taker from './taker.vue';
import FeedRights from './feed-rigths.vue';
import NsLoader from 'fundation-app-vuejs/src/components/partials/ns-vue-loader';
import LoadingTemplate from '../../partials/ns-loader-template.vue';
import ConfigurationView from './configuration.vue';
import moment from 'moment';
import ModalExtendFeed from './modal-extend-feed.vue';
import ModalConfirmFeed from './modal-confirm-feed.vue';
import FeedModification from './feed-modification.vue';
import ModalSendEmail from './modal-send-email.vue';
import FeedSourceExternalInfo from './feed-source-external-info.vue';
import FeedUpdateWorkOrder from './feed-update-work-order.vue';
import { mapGetters } from 'vuex';

export default {

    components: {
        Taker,
        FeedRights,
        NsLoader,
        LoadingTemplate,
        ConfigurationView,
        ModalExtendFeed,
        ModalSendEmail,
        ModalConfirmFeed,
        FeedModification,
        FeedSourceExternalInfo,
        FeedUpdateWorkOrder,
    },

    props: {
        feed: {
            type: Object,
            required: true,
        },
        broadcastRight: {
            type: Array,
            required: true,
        },
        events: {
            type: Array,
            required: true,
        },
        feeds: {
            type: Array,
            required: true,
        },
        feedResources: {
            type: Array,
            required: true,
        },
    },

    data (){
        return {
            stopFeedTimeoutId: null,
            runningFeedModificationRequest: null,
            activeName: 'rights',
            configurations: [],
            feedResourceConfigurations: [],
            loading: false,
            universe: null,
            expanded: false,

            // prevent new watchFeedModificationRequest on dataFetch if already watching
            isWatchingStatus: false,
            mainSourceName: '',
            backupSourceName: '',
            videoSource: null,
        };
    },

    computed: {
        ...mapGetters([
            'userIsAtLeastAdmin',
            'userIsEntityAdmin',
            'userIsAtLeastManager'
        ]),
        entityUid(){
            return this.feed.scopes.entity_uid;
        },
        disableConfirmButton (){
            if (!this.feed.confirmed){
                return false;
            }
            let date = this.feed.confirmed_start_date;
            return moment.utc(date).diff(moment(), 'minutes') < 15;
        },
        disabledStartReason(){
            if (!this.feed.confirmed){
                return `Feed must be confirmed.`;
            }else if(this.feedIsStarting){
                return `Feed is already starting.`;
            }
            return `Feed will overlap with another feed related to its feed resource.`;
        },
        feedIsStarting(){
            return moment.utc(this.feed.confirmed_start_date).diff(moment(), 'minutes') < 15;
        },
        feedIsRunning(){
            return this.feed.status === 'RUNNING';
        },
        canStartFeedNow(){
            if(!this.feed.feed_resource_uid){
                return true;
            }
            // get feeds with same feed-resource
            let feedsRelatedToResource = this.feeds.filter(
                feed => feed.feed_resource_uid === this.feed.feed_resource_uid
            );

            //Check if some feeds related to resource are running
            let someRelatedFeedAreRunning = feedsRelatedToResource.some(feed => feed.status === 'RUNNING');

            // check if some feeds related to resource will start during the feed we want to start
            let someRelatedFeedWillStart = feedsRelatedToResource.some(feed => {
                let feedConfirmedStartDate = moment(feed.confirmed_start_date);
                let confirmedEndDate = moment(this.feed.confirmed_end_date);
                return feedConfirmedStartDate.isBefore(confirmedEndDate)
                    && feed.uid !== this.feed.uid
                    && feed.status !== 'FINISHED'
                    && feed.archived === false;
            });

            return !someRelatedFeedAreRunning && !someRelatedFeedWillStart;
        },
        disabledStartNowButton(){
            return !this.feed.confirmed || this.feedIsStarting || !this.canStartFeedNow;
        },
        videoSourceMainDetails(){
            if(this.videoSource)
                return `${this.videoSource.type.toLowerCase()}://${this.videoSource.multicast_network_ip_main}:${this.videoSource.port_main}@${this.videoSource.multicast_network_src_main}`;
        },
        videoSourceBackupDetails(){
            if(this.videoSource)
                return `${this.videoSource.type.toLowerCase()}://${this.videoSource.multicast_network_ip_backup}:${this.videoSource.port_backup}@${this.videoSource.multicast_network_src_backup}`;
        },
        toLoad () {
            let modelsTofetch = [];
            if(this.feed.feed_resource_uid){
                modelsTofetch.push({
                    model: 'feedResourceConfigurations',
                    name: 'feedResourceConfigurations',
                    filters: {
                        feed_resource_uid: this.feed.feed_resource_uid,
                        finished: false,
                    }
                });
            }

            return [
                {
                    name: 'configurations',
                    model: 'configurations',
                    filters: {
                        feed: this.feed.uid,
                        cancelled: false,
                    }
                },
                {
                    name: 'feedModificationRequests',
                    model: 'feedModificationRequests',
                    filters: {
                        feed: this.feed.uid,
                        status__in: 'PENDING,RUNNING',
                    }
                },
                {
                    name: 'universe',
                    model: 'universes',
                    uid: this.event.universe_uid,
                },
                ...modelsTofetch
            ];
        },
        duration() {
            return this.endDateTimeUtc.diff(this.startDateTimeUtc, 'minutes');
        },
        startDateTimeUtc() {
            if(this.feed.confirmed){
                return moment.utc(this.feed.confirmed_start_date);
            }
            return moment.utc(this.feed.start_date);
        },
        endDateTimeUtc() {
            if(this.feed.confirmed){
                return moment.utc(this.feed.confirmed_end_date);
            }
            return moment.utc(this.feed.end_date);
        },
        feedCanBeStopped (){
            return this.feed.status === 'RUNNING' &&
                   this.feed.confirmed &&
                   this.userIsAtLeastManager;
        },
        feedInputCanBeModified (){
            return this.feed.status === 'RUNNING'
                && (this.userIsAtLeastAdmin || this.userIsEntityAdmin(this.entityUid))
                && this.feed.source_type === 'internal';
        },
        feedDescription (){
            return this.feed.description || 'No description provided';
        },
        feedSourceType() {
            return this.feed.source_protocol_type.toUpperCase()
        },
        enableDeletion() {
            let feedRights = this.broadcastRight.filter(
                br => br.feed_uid === this.feed.uid
            );
            return feedRights.length === 0 && this.feed.status === 'AVAILABLE';
        },

        endDate (){
            let date = this.feed.confirmed ? this.feed.confirmed_end_date : this.feed.end_date;
            return  moment.utc(date).format('YYYY.MM.DD');
        },
        endTimeUtc (){
            let date = this.feed.confirmed ? this.feed.confirmed_end_date : this.feed.end_date;
            return  moment.utc(date).format('HH:mm');
        },
        endTimeLocal (){
            let date = this.feed.confirmed ? this.feed.confirmed_end_date : this.feed.end_date;
            return  moment(date).format('HH:mm');
        },
        startDate (){
            let date = this.feed.confirmed ? this.feed.confirmed_start_date : this.feed.start_date;
            return  moment.utc(date).format('YYYY.MM.DD');
        },
        startTimeUTC (){
            let date = this.feed.confirmed ? this.feed.confirmed_start_date : this.feed.start_date;
            return  moment.utc(date).format('HH:mm');
        },
        startTimeLocal (){
            let date = this.feed.confirmed ? this.feed.confirmed_start_date : this.feed.start_date;
            return  moment(date).format('HH:mm');
        },
        event (){
            return this.events.find(event => event.uid == this.feed.event_uid);
        },
        canExtendFeed (){
            // TODO : Rewrite condition to display button only of status is RUNNING or STARTING (ok)
            // and now < (end_time - X min)
            return ['STARTING','RUNNING'].includes(this.feed.status)
            && (this.userIsAtLeastAdmin || this.userIsEntityAdmin(this.entityUid));
        },
        feedResourceName(){
            let feedResource = this.feedResources
            .find(resource => resource.uid ===  this.feed.feed_resource_uid);

            if(feedResource){
                return feedResource.display_name;
            }
            return '';
        }
    },
    watch:{
        feed:{
            handler(){
                this.setFeedNetworkData();
            },
            deep: true,
        }
    },
    mounted (){
        this.setFeedNetworkData();
    },

    methods: {
        setFeedNetworkData(){
            if(this.feed.confirmed && this.feed.booking_type === 'automatic'){
                this.getMainSourceName(this.feed.booking_ip_main_uid);
                this.getBackupSourceName(this.feed.booking_ip_backup_uid);
            } else if(this.feed.confirmed){
                this.getVideoSourceDetails(this.feed.video_source_uid);
            }
        },
        openEmailModal (){
            this.$refs['modal-send-email'].open(this.feed);
        },
        confirmFeed (){
            this.$refs['modal-confirm-feed'].open(this.feed, this.event, this.universe);
        },
        startFeedNow(){
            let feed = {...this.feed};
            feed.confirmed_start_date = moment.utc().format('YYYY-MM-DDTHH:mm:ss');
            this.$store.dispatch('patchItem',{
                item:{
                    uid: feed.uid,
                    confirmed_start_date: feed.confirmed_start_date,
                    url: feed.url
                },
                model: 'feeds'
            }).then((res) => {
                this.$message({
                    message: `Feed ${this.feed.display_name} successfully started!`,
                    type: 'success'
                });
                this.$emit('getUpdatedFeed', res.uid);
            }).catch(e => {
                console.error(e);
                this.$message({
                    message: `An error occured while starting ${this.feed.display_name}. Please retry.`,
                    type: 'success'
                });
            });
        },
        updateWorkOrder (){
            this.$refs['feed-update-work-order'].open(this.feed);
        },
        openModalExtendFeed (){
            this.$refs['modal-extend-feed'].open(this.feed);
        },
        openModalEditInput (){
            this.$refs['modal-edit-input'].open(this.feed, this.event);
        },
        getMainSourceName(uid){
            this.$store.dispatch('remoteGet',{url: `ip/?uid=${uid}`,})
            .then(res=>{
                this.mainSourceName = res.data.results[0].name;
            });
        },
        getBackupSourceName(uid){
            this.$store.dispatch('remoteGet',{url: `ip/?uid=${uid}`,})
            .then(res=>{
                this.backupSourceName = res.data.results[0].name;
            });
        },
        getVideoSourceDetails(uid){
            this.$store.dispatch('remoteGet',{url: `video-source/?uid=${uid}`,})
            .then(res=>{
                this.$set(this,'videoSource', res.data.results[0]);
            });
        },
        deleteFeed() {
            this.$store.dispatch('patchItem', {
                item: {
                    uid: this.feed.uid,
                    url: this.feed.url,
                    archived: true,
                },
                model: 'feeds'
            }).then(() => {
                this.$message.success({
                    message: 'The feed has been archived'
                });
                this.$emit('unselectFeed');
            }).catch(() => {
                this.$message.error({
                    message: 'The feed couldn\'t be archived'
                });
            });
        },
        hideDeletePopover() {
            if (this.$refs['popover']) {
                this.$refs['popover'].showPopper = false;
            }
        },
        sendEmit() {
            this.$emit('on-update-broadcast-right');
        },
        editFeed (){
            this.$emit('on-update-feed', this.feed);
        },
        onDataFetched (res){
            this.$set(this, 'feedResourceConfigurations', res.feedResourceConfigurations);
            this.$set(this, 'universe', res.universe);
            this.$set(this, 'configurations', res.configurations);
            this.$set(this, 'runningFeedModificationRequest', res.feedModificationRequests[0]);

            if(this.runningFeedModificationRequest && !this.isWatchingStatus){
                this.loading = true;
                this.watchFeedModificationRequest(this.runningFeedModificationRequest.url);
            }
        },
        triggerRefresh (){
            this.$refs['ns-loader'].triggerRefresh();
        },
        onTriggerRefresh (){
            this.$emit('on-trigger-refresh');
        },
        hidePopoverStopFeed() {
            if (this.$refs['popover-stop-feed']) {
                this.$refs['popover-stop-feed'].showPopper = false;
            }
        },
        stopFeed (){
            this.hidePopoverStopFeed();
            this.loading = true;
            this.$store.dispatch('createItem', {
                item: {
                    action: 'STOP',
                    feed_uid: this.feed.uid,
                    end_date: moment().format(),
                },
                model: 'feedModificationRequests',
                url: this.$store.state.api.meta.listModels.feedModificationRequests.url
            }).then((res) => {
                this.watchFeedModificationRequest(res.url);
            });
        },

        watchFeedModificationRequest (url){
            this.loading = true;
            this.isWatchingStatus = true;
            clearTimeout(this.stopFeedTimeoutId);
            this.$store.dispatch('remoteGet', {
                url: url
            }).then(res => {
                if (res.data && ['COMPLETED'].includes(res.data.status)) {
                    if (res.data.action === 'STOP') {
                        this.$message({
                            message: `Feed ${this.feed.display_name} successfully stopped!`,
                            type: 'success'
                        });
                        this.isWatchingStatus = false;
                        this.loading = false;
                        this.$emit('on-feed-stopped');
                    } else if (res.data.action === 'EXTEND') {
                        this.$message({
                            message: `Feed ${this.feed.display_name} successfully extended!`,
                            type: 'success'
                        });
                        this.isWatchingStatus = false;
                        this.loading = false;
                        this.$emit('on-extend-feed');
                    } else if (res.data.action === 'SEND_EXTERNAL_SOURCE_NOTIF') {
                        this.$message({
                            message: `Emails successfully sent`,
                            type: 'success'
                        });
                        this.isWatchingStatus = false;
                        this.loading = false;
                    } else if ( res.data.action === 'UPDATE'){
                        this.$emit('getUpdatedFeed', res.data.feed_uid)
                        this.$message({
                            type: 'success',
                            message: `Feed ${this.feed.display_name} input updated`
                        });
                        this.isWatchingStatus = false;
                        this.loading = false;
                    }
                }
                else if (res.data && ['FAILED'].includes(res.data.status)) {
                    console.error(res.data.verbose_status);
                    if (res.data.action === 'STOP') {
                        this.$message.error(`Error on stop feed ${this.feed.display_name}`);
                    } else if (res.data.action === 'EXTEND') {
                        this.$message.error(`Error on extending feed ${this.feed.display_name}`);
                    } else if (res.data.action === 'SEND_EXTERNAL_SOURCE_NOTIF') {
                        this.$message.error(`Error on sending email`);
                    } else if (res.data.action === 'UPDATE') {
                        this.$message.error(`Error on updating ${this.feed.display_name} input`)
                    }
                    this.loading = false;
                    this.isWatchingStatus = false;
                    this.$set(this, 'runningFeedModificationRequest', null);
                } else {
                    this.stopFeedTimeoutId = setTimeout(() => {
                        this.watchFeedModificationRequest(url);
                    }, 3000);
                }
            });
        }
    },
};
</script>

<style lang="scss">
.feed-details-container{
    background-color: #222;
    .details--description{
        white-space: pre;
    }
    .list-filters{
        display: flex;
        justify-content: flex-end;
        margin-bottom: 10px;

        & > *:not(:last-child){
            margin-right: 10px;
        }
    }
    &.gcmcn-card{
        background: linear-gradient(360deg, #111111 47.89%, #222222 100%) !important;
    }

    .feed-details{
        min-height: 70px;
        .text-right {
            display: flex;
            align-items: center;
            float: right;
        }
        .timezone-label {
            margin-left: 5px;
            font-size: 9px;
        }

    }
}
.vue-tooltip {
    z-index: 800;
}
.gcmcn-this-warning-btn {
    display: block;
    background-color: #E6A23C;
}
.mb-1{
    margin-bottom: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/page/Feeds/feed-details.vue